import { Weapon, type WeaponConfig } from './Weapon';

const MACHINEGUN_CONFIG: WeaponConfig = {
  id: 'machinegun',
  name: 'Пулемёт',
  // economy W12, calibrated to budget=30+10L
  price: 5400,
  // Скорострельность ×1.3 (113 / 1.3 ≈ 87 ms = ~11.5 выстр/с вместо ~8.8).
  fireRateMs: 87,
  bulletsPerShot: 1,
  spreadDeg: 2,
  soundKey: 'pistol_shot',
  soundVolume: 0.4,
  shakeShoot: { intensity: 0.002, duration: 30 },
  magazineSize: 100,
  reloadTimeMs: 5000,
  fireMode: 'auto',
  // windupTimeMs / windupSpreadMult убраны — стреляет сразу на полной точности.
  // Раньше было: 500 ms раскрутки с разлётом ×4.5.
  bulletWidth: 5,
  bulletHeight: 3,
  recoilForce: 3,
};

export function createMachineGun(): Weapon {
  return new Weapon(MACHINEGUN_CONFIG);
}
